import $ from 'jquery';

import {
  helperResponsive,
  getBreakpoint,
  isNotBreakpoint,
  isBreakpoint
} from './helper-responsive.js';
import siteHeader from './site-header';
import siteNavigationMenuAim from './site-navigation-menu-aim';
import siteNavigation from './site-navigation';
import siteContent from './site-content';

document.addEventListener("DOMContentLoaded", () => {
  const bodyElement = $('body');
  const loadingClass  = 'loading';

  console.log('APP DOMContentLoaded');
  setTimeout(() => {
    bodyElement.removeClass(loadingClass);
  }, 250);

  helperResponsive();

  siteHeader();
  siteNavigationMenuAim();
  siteNavigation();
  siteContent();
});
